import {
  DashboardModuleListItem, StatusBadge,
} from '@domain-group/suit-theme'

import useOrder from '@hooks/useOrder'
import useStatus from '@hooks/useStatus'

const OrderListItem = (props: { orderId: number }) => {
  const { orderId } = props

  const { order, campaign } = useOrder({ id: orderId })

  const { color, status } = useStatus({ id: order.status_id })

  return (
    <DashboardModuleListItem
      childrenHolderProps={{ alignItems: 'center', maxWidth: '60%' }}
      title={campaign?.title}
    >
      {/* @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`Order #${order.id} | ${order.title}`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>

      <StatusBadge
        boxProps={{ marginLeft: 'medium' }}
        color={color}
        ghost
        // @ts-expect-error TS2339
        text={status.title}
      />
    </DashboardModuleListItem>
  )
}

export default OrderListItem
